<div class="authLangSwitch">
  @for (lang of languages; track lang) {
    <button type="button" [class.active]="lang === currentLanguage" (click)="useLanguage(lang)">
      {{ lang | uppercase }}
    </button>
  }
</div>
<router-outlet></router-outlet>
<p class="appVersion paragraphText m-0">v. {{appVersion}}</p>
